import { getMessages } from '../../../../../../../store/constants';

export const CARD_ATTACHMENTS_DROP_PANEL_DROP = getMessages().getText('card_form_attachments_drop_panel.drop');
export const CARD_ATTACHMENTS_DROP_PANEL_DROP_COMMENTS = getMessages().getText('card_form_attachments_drop_panel.drop.comments');
export const CARD_ATTACHMENTS_DROP_PANEL_DRAG = getMessages().getText('card_form_attachments_drop_panel.drag');
export const CARD_ATTACHMENTS_DROP_PANEL_UPLOAD = getMessages().getText('card_form_attachments_drop_panel.upload');
